import { render, staticRenderFns } from "./DetailRental.vue?vue&type=template&id=74fd6c90&"
import script from "./DetailRental.vue?vue&type=script&lang=js&"
export * from "./DetailRental.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports